import React, { Component } from 'react';
import KickImage from 'Reuseables/KickImage';
import {
    Modal,
    ModalHeader,
    ModalBody,
    Container,
    Row,
    Col } from 'reactstrap';
import CloseIcon from "../../images/close-button-search.png"
import { Button } from '../Forms';
import { connect } from 'react-redux';
import { doSentLinkVerificationEmail } from '../../actions/authAction';
import welcomeIcon from "../../images/welcome.png"

class ModalAfterRegister_New extends Component{
    constructor(props){
        super(props);
        this._onSentEmail = this._onSentEmail.bind(this);
    }

    _onSentEmail(){
        this.props.submit();
        setTimeout(()=>{
            if(this.props.isOpen===true)
                this.props.onToggle();
            this.props.onSuccess();
        },300)
    }

    render(){
        return(
            
            <Modal isOpen={this.props.isOpen} toggle={this.props.onToggle} className="modal__welcome__new">
                
                <ModalBody>
                    <Container>
                        <p className="closeIcon">
                          <KickImage src={CloseIcon} onClick={this.props.onToggle} />
                        </p>
                        <KickImage style={{width: '100%'}} src={welcomeIcon} />
                        <p>Your account is now ACTIVE!</p>
                        <p>With the warmest heart, we would like to welcome you to our ever-growing sneaker-community.<br />
                        Buy sneakers with confident and hassle-free, or sell sneakers efficiently and get your investment return handsomely.</p>

                        <Button className="green-btn" onClick={this.props.onToggle}>START BROWSING</Button>
                    </Container>
                </ModalBody>
            </Modal>
        )
    }
}

const mapStateToProps = ({dataAuth:{ userSentLinkEmailVerify }})=>({
    data : userSentLinkEmailVerify
})

const mapDispatchToProps = dispatch =>({
    submit : ()=> dispatch(doSentLinkVerificationEmail())
})

export default connect(mapStateToProps,mapDispatchToProps)(ModalAfterRegister_New);
